/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react';
import { GtmManager } from '../../utils/GtmManager';

interface Props {
  text: string;
  url?: string;
  title?: string;
  className?: string;
  openInNewWindow?: boolean;
}

const BlockLinkSameTarget: FC<Props> = ({ text, url, title, className }) => {
  const clickLink = () => {
    if (url) {
      GtmManager.sendHeaderLinkClickGTM(url);
    }
  };
  return (
    <>
      <div
        className={`block-link ${
          typeof className === 'undefined' ? '' : className
        }`}
      >
        <a href={url} onClick={clickLink} title={title}>
          {text}
        </a>
      </div>
    </>
  );
};

export default BlockLinkSameTarget;
